import React, { useRef } from 'react';
import { FaLinkedin, FaGithub, FaSun, FaMoon} from 'react-icons/fa';
import { LuDownload } from 'react-icons/lu';
import desktopStyles from '../../styles/navigation/DesktopNavbar.module.css';
import utilities from '../../styles/utilities.module.css';
import { getResumeUrl } from '../../utils/resumeUtils';
import { useTheme } from '../../hooks/useTheme';
import { githubUrl, linkedinUrl } from '../../data/personal';
import { wrapIcon } from '../../utils/iconWrapper';
import { NavBarProps } from './types';

const LinkedInIcon = wrapIcon(FaLinkedin);
const GitHubIcon = wrapIcon(FaGithub);
const ResumeIcon = wrapIcon(LuDownload);
const SunIcon = wrapIcon(FaSun);
const MoonIcon = wrapIcon(FaMoon);

const DesktopNavbar: React.FC<NavBarProps> = ({ currentSection, onSectionChange }) => {
    // Theme management
    const { toggleTheme, isLight } = useTheme();

    // Update the current section when the element is clicked
    const navRef = useRef<HTMLElement>(null);
    const handleNavClick = (section: string, e: React.MouseEvent) => {
        e.preventDefault();
        const sectionElement = document.getElementById(section);
        if (sectionElement) {
            sectionElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        onSectionChange(section);
    };

    return (
        <nav className={desktopStyles.navbar} ref={navRef}>
            <ul className={desktopStyles.desktopNavbarItemHolder}>
                <li className={utilities.navItemPaddingCompact}>
                    <a
                        onClick={(e) => handleNavClick('home', e)}
                        href="#home"
                        className={`${utilities.interactivePaddingCompact} ${currentSection === 'home' ? desktopStyles.active : ''}`}
                    >
                        Home
                    </a>
                </li>
                <li className={utilities.navItemPaddingCompact}>
                    <a
                        onClick={(e) => handleNavClick('projects', e)}
                        href="#projects"
                        className={`${utilities.interactivePaddingCompact} ${currentSection === 'projects' ? desktopStyles.active : ''}`}
                    >
                        Projects
                    </a>
                </li>
                <li className={utilities.navItemPaddingCompact}>
                    <a
                        onClick={(e) => handleNavClick('career', e)}
                        href="#career"
                        className={`${utilities.interactivePaddingCompact} ${currentSection === 'career' ? desktopStyles.active : ''}`}
                    >
                        Career
                    </a>
                </li>
                <li className={desktopStyles.separator}>&nbsp;</li>
                <li className={utilities.navItemPaddingCompact}>
                    <a
                        href={linkedinUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={utilities.interactivePaddingCompact}
                    >
                        <LinkedInIcon /> LinkedIn
                    </a>
                </li>
                <li className={utilities.navItemPaddingCompact}>
                    <a
                        href={githubUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={utilities.interactivePaddingCompact}
                    >
                        <GitHubIcon /> GitHub
                    </a>
                </li>
                <li className={utilities.navItemPaddingCompact}>
                    <a
                        href={getResumeUrl()}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={utilities.interactivePaddingCompact}
                    >
                        <ResumeIcon /> Resume
                    </a>
                </li>
                <li className={desktopStyles.separator}>&nbsp;</li>
                <li className={utilities.navItemPaddingCompact}>
                    <button
                        onClick={toggleTheme}
                        className={`${utilities.interactivePaddingCompact} ${desktopStyles.themeToggle}`}
                        aria-label={`Switch to ${isLight ? 'dark' : 'light'} mode`}
                    >
                        {isLight ? <MoonIcon /> : <SunIcon />} 
                        {isLight ? 'Dark' : 'Light'}
                    </button>
                </li>
            </ul>
        </nav>
    );
}

export default DesktopNavbar;